// ABOUTME: Factory for creating Cloudflare backend provider
// ABOUTME: Bundles auth, database, and storage providers into BackendProvider

import type { BackendProvider } from '../interfaces'
import { CloudflareAuthProvider } from './auth'
import { CloudflareDatabaseProvider } from './database'
import { CloudflareStorageProvider } from './storage'

export interface CloudflareConfig {
  apiUrl: string
}

export function createCloudflareProvider(config: CloudflareConfig): BackendProvider {
  return {
    auth: new CloudflareAuthProvider(config.apiUrl),
    database: new CloudflareDatabaseProvider(config.apiUrl),
    storage: new CloudflareStorageProvider(config.apiUrl),
  }
}
